import React from 'react';
import {
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
} from 'antd';
import moment from 'moment';
import SelectProvince from 'modules/Profile/Components/SelectProvince';
import SelectWard from 'modules/Profile/Components/SelectWard';

const buildRules = (field) => {
  const rules = [];
  if (field.required) {
    rules.push({
      required: true,
      message: field.required_message || `Vui lòng nhập ${field.label}`,
    });
  }
  if (field.type === 'email') {
    rules.push({ type: 'email', message: 'Email không hợp lệ' });
  }
  if (field.pattern) {
    rules.push({
      pattern: new RegExp(field.pattern),
      message: field.pattern_message || 'Giá trị không hợp lệ',
    });
  }
  return rules;
};

const TsaTrialExamFormFields = ({
  fields = [],
  period,
  provinces,
  wards,
  onProvinceChange,
  isLoggedIn,
  formDisabled,
}) => {
  const examDateOptions = period?.exam_date_options || [];

  return fields.map((field, index) => {
    const fieldKey = `${field.name || field.type}-${index}`;

    if (field.type === 'school') {
      const labels = field.labels || {};
      const placeholders = field.placeholders || {};
      return (
        <Row gutter={16} key={fieldKey}>
          <Col xs={24} md={8}>
            <SelectProvince
              name="school_province"
              options={provinces}
              required={!!field.required}
              onChange={onProvinceChange}
              disabled={formDisabled}
            />
          </Col>
          <Col xs={24} md={8}>
            <SelectWard
              name="school_ward"
              options={wards}
              required={!!field.required}
              disabled={formDisabled}
            />
          </Col>
          <Col xs={24} md={8}>
            <Form.Item
              label={labels.school || 'Trường THPT'}
              name="school_name"
              rules={[
                {
                  required: !!field.required,
                  message: `Vui lòng nhập ${labels.school || 'Trường THPT'}`,
                },
              ]}
            >
              <Input
                disabled={formDisabled}
                placeholder={placeholders.school || 'Tên trường THPT'}
              />
            </Form.Item>
          </Col>
        </Row>
      );
    }

    if (field.type === 'radio') {
      return (
        <Form.Item
          key={fieldKey}
          label={field.label}
          name={field.name}
          rules={buildRules(field)}
        >
          <Radio.Group disabled={formDisabled}>
            {(field.options || []).map((opt) => (
              <Radio key={opt.value} value={opt.value}>
                {opt.label}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
      );
    }

    if (field.type === 'exam_date') {
      return (
        <Form.Item
          key={fieldKey}
          label={field.label}
          name={field.name}
          rules={buildRules(field)}
        >
          <Radio.Group disabled={formDisabled}>
            {examDateOptions.map((opt) => (
              <Radio key={opt.value} value={opt.value}>
                {opt.label}
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
      );
    }

    if (field.type === 'date') {
      return (
        <Form.Item
          key={fieldKey}
          label={field.label}
          name={field.name}
          rules={buildRules(field)}
        >
          <DatePicker
            className="w-100"
            format="DD/MM/YYYY"
            placeholder={field.placeholder}
            disabled={formDisabled}
            disabledDate={(current) =>
              current && current > moment().endOf('day')
            }
          />
        </Form.Item>
      );
    }

    const inputDisabled =
      formDisabled ||
      (field.readonly_when_logged_in && isLoggedIn && field.name === 'account_email');

    return (
      <Form.Item
        key={fieldKey}
        label={field.label}
        name={field.name}
        rules={buildRules(field)}
      >
        <Input
          disabled={inputDisabled}
          placeholder={field.placeholder}
          maxLength={field.max_length}
        />
      </Form.Item>
    );
  });
};

export default TsaTrialExamFormFields;
